module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_invite_default_dark.65ff0.png";